/**
 * Short labels for drill-hole markers on Leaflet maps.
 * Families: YYSCM… (numeric tail), YYGT… (GT + number), SRK… (SRK + last numeric segment).
 */

/**
 * @param {string|null|undefined} holeId
 * @returns {string}
 */
export function formatMapHoleLabel(holeId) {
  if (holeId == null) return '';
  const id = String(holeId).trim();
  if (!id) return '';

  const scm = id.match(/^\d{2}SCM0*(.+)$/i);
  if (scm) {
    const tail = scm[1];
    return tail || id;
  }

  const gt = id.match(/^\d{2}GT0*(\d+)([A-Za-z]?)$/i);
  if (gt) {
    const n = parseInt(gt[1], 10);
    const suffix = gt[2] || '';
    return `GT${Number.isFinite(n) ? n : gt[1]}${suffix}`;
  }

  if (/^SRK/i.test(id)) {
    const digits = [...id.matchAll(/(\d+)/g)].map((m) => m[1]);
    if (digits.length) {
      const n = parseInt(digits[digits.length - 1], 10);
      if (Number.isFinite(n)) return `SRK${n}`;
    }
    return id;
  }

  return id;
}
